import Link from "next/link";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Feature_collections_data from "../../data/Feature_collections_data";
import Image from "next/image";

const Explore_collection_item = ({
  itemFor,
  selectedCampaigns,
  selectedSuperCampaigns,
  selectedCountries,
  selectedImpactCategory,
  searchedObject,
  allData,
}) => {
  const { sortedCollectionData } = useSelector((state) => state.counter);

  const [itemData, setItemData] = useState([]);
  const [localCampaigns, setCampaigns] = useState([]);

  useEffect(() => {
    if (itemFor === "userPage") {
      setItemData(Feature_collections_data.slice(0, 4));
      // console.log(itemData);
    } else {
      setItemData(sortedCollectionData);
    }
  }, [sortedCollectionData, itemFor]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        //const response = await fetch("https://api.impactoverse.com/api/app/all-campaigns");
        const data = allData;

        if (data) {
          // Filter the data based on selected options
          const filteredCampaigns = data.allCampaigns.filter((campaign) => {
            return (
              !selectedCampaigns ||
              selectedCampaigns.includes(campaign.overview.campaignName) ||
              !selectedSuperCampaigns ||
              (campaign.overview.isSuperCampaign &&
                selectedSuperCampaigns.includes(
                  campaign.overview.campaignName
                )) ||
              !selectedCountries ||
              selectedCountries.includes(campaign.overview.country) ||
              !selectedImpactCategory ||
              selectedImpactCategory.includes(campaign.impact.category) ||
              searchedObject.label === campaign.overview.campaignName ||
              (searchedObject.heading === "Countries" &&
                searchedObject.label === campaign.overview.country) ||
              (searchedObject.heading === "Impact Categories" &&
                searchedObject.label === campaign.impact.category)
            );
          });
          console.log(
            "selected searched ",
            searchedObject.label,
            searchedObject.heading
          );
          console.log(filteredCampaigns);

          // setCampaigns(filteredCampaigns);
          let tempArray = [];
          {
            const newObj = {
              count: data?.count || {},
              campaigns:
                filteredCampaigns.length > 0
                  ? filteredCampaigns
                  : data.allCampaigns,
            };
            tempArray.push(newObj);
          }
          // console.log("This is new Obj", newObj.count);
          setCampaigns(tempArray);
        } else {
          console.error("API request failed:", data.error);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [
    selectedCampaigns,
    selectedSuperCampaigns,
    selectedCountries,
    selectedImpactCategory,
    searchedObject,
  ]);

  return (
    <>
      {localCampaigns.map((item) => {
        const { campaigns } = item;
        // console.log("Campaign Id", campaigns);

        return campaigns.map((campaignItem, campaignIndex) => {
          const {} = campaignItem;
          // console.log("Campaign Item", campaignItem);
          const imageName = campaignItem.overview.campaignName;
          const campaignId = campaignItem._id;
          let hrefOrg ;
          if (campaignItem.brandId === "63c3e85f4df378abfe55ccd9") {
            hrefOrg = `brands/${campaignItem.brandId}`;
          } else {
            hrefOrg = `causes/${campaignItem.causeId}`;
          }
          const stringWithoutSpaces = imageName.replace(/\s/g, "");
          const campaignImageTemp =
            "/images/collections/campaigns/" + stringWithoutSpaces + ".png";
          const campaignImageTempSmall1 =
            "/images/collections/campaigns/" +
            stringWithoutSpaces +
            "/" +
            stringWithoutSpaces +
            "_1" +
            ".png";
          const campaignImageTempSmall2 =
            "/images/collections/campaigns/" +
            stringWithoutSpaces +
            "/" +
            stringWithoutSpaces +
            "_2" +
            ".png";
          const campaignImageTempSmall3 =
            "/images/collections/campaigns/" +
            stringWithoutSpaces +
            "/" +
            stringWithoutSpaces +
            "_3" +
            ".png";
          const organizationImage =
            "/images/collections/campaigns/" +
            stringWithoutSpaces +
            "/" +
            stringWithoutSpaces +
            "_org" +
            ".png";
          const orgName = [
            "AUNUA GLOBAL",
            "AdventureLOGUE",
            "BEAR MARTIAL ARTS",
            "Impactoverse",
            "We Rise Together Foundation",
            "AUNUA GLOBAL",
            "YOUTH AND CHILDREN EDUCATION",
            "Oxford Dog Training",
            "AUNUA GLOBAL",
            "THINK OCEAN",
            "ACTION FOR EQUALITY",
          ];
          return (
            <article key={campaignIndex}>
              <div className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2xl border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg">
                <Link
                  href={`campaign/${campaignId}`}
                  className="flex space-x-[0.625rem]"
                >
                  <span className="w-[74.5%]">
                    <Image
                      width={152}
                      height={242}
                      src={campaignImageTemp}
                      alt="item 1"
                      className="h-full w-full rounded-[0.625rem] object-cover"
                      loading="lazy"
                    />
                  </span>
                  <span className="flex w-1/3 flex-col space-y-[0.625rem]">
                    <Image
                      width={68}
                      height={74}
                      src={campaignImageTempSmall1}
                      alt="item 1"
                      className="h-full w-full rounded-[0.625rem] object-cover"
                      loading="lazy"
                    />
                    <Image
                      width={68}
                      height={74}
                      src={campaignImageTempSmall2}
                      alt="item 1"
                      className="h-full w-full rounded-[0.625rem] object-cover"
                      loading="lazy"
                    />
                    <Image
                      width={68}
                      height={74}
                      src={campaignImageTempSmall3}
                      alt="item 1"
                      className="h-full w-full rounded-[0.625rem] object-cover"
                      loading="lazy"
                    />
                  </span>
                </Link>

                <Link
                  href={`campaign/${campaignId}`}
                  className="font-display hover:text-accent dark:hover:text-accent text-jacarta-700 mt-4 block text-base dark:text-white"
                >
                  {campaignItem.overview.campaignName}
                </Link>

                <div className="mt-2 flex items-center justify-between text-sm font-medium tracking-tight">
                  <div className="flex flex-wrap items-center">
                    <span className="dark:text-jacarta-400 mr-1"> by </span>{" "}
                    <Link href={hrefOrg} className="ml-2 shrink-0">
                      <Image
                        width={20}
                        height={20}
                        src={organizationImage}
                        alt="owner"
                        className="h-5 w-5 rounded-full"
                      />
                    </Link>
                  </div>
                  <span className="dark:text-jacarta-300 text-sm">
                    {/* 10K Items */}
                  </span>
                </div>
                {/* <Link href={`/404`} className="text-accent">
                  <span className="uppercase">{orgName[campaignIndex]}</span>
                </Link> */}
              </div>
            </article>
          );
        });
      })}
    </>
  );
};

export default Explore_collection_item;
